/**
 * Store quản lý danh sách các role trong hệ thống
 */

import { Role } from '@/plugins/api'
import { isEmpty } from 'lodash-es'
import alert from '@/plugins/alert'

export default {
  namespaced: true,
  state: {
    role: {},
    roles: []
  },
  actions: {
    async fetchRoles({ state, commit }) {
      if (isEmpty(state.roles)) {
        try {
          const { roles = [] } = await Role.fetch({ _limit: -1 })
          commit('setRoles', roles)
        } catch (error) {
          console.error(error)
        }
      }
    },
    async updateRolePolicies({ state, commit }, { id, policies }) {
      try {
        const response = await Role.updateRole(id, { policies })
        if (response.ok) {
          const newRoles = state.roles.map(role => {
            if (role.id === id) {
              role.policies = policies
            }
            return role
          })
          commit('setRoles', newRoles)
          alert.updateSuccess('phân quyền')
        } else {
          alert.updateError('Cập nhật phân quyền thất bại')
        }
      } catch (error) {
        alert.updateError('Cập nhật phân quyền thất bại')
        console.error(error)
      }
    },
    setRole({ commit }, role) {
      commit('setRole', role)
    }
  },
  mutations: {
    setRoles(state, roles) {
      state.roles = roles
    },
    setRole(state, role) {
      state.role = role
    }
  },
  getters: {
    role: state => state.role,
    roleIdByName: state => name => {
      const { id = '' } = state.roles.find(role => role.name === name) || {}
      return id
    }
  }
}
